<div class="booking-complete" *ngIf="dataBookingLoaded">
  <div class="container padding-bottom-32">

    <app-language-selector></app-language-selector>

    <h2 class="margin-top-0 text-dark-blue margin-right-64"
      [innerHTML]="appCopy.panelHeader['flybackDetailsTitle'+selectedLanguage]">We are confirming your booking...</h2>
    <p [innerHTML]="appCopy.panelHeader['flybackDetailsDescription'+selectedLanguage]">While you wait, please provide us
      with some additional information</p>
  </div>
  <div *ngIf="flightDirection === 1" class="hero hero--outbound margin-bottom-12" style="height: 208px;">
  </div>

  <div *ngIf="flightDirection === 2" class="hero hero--inbound margin-bottom-12" style="height: 208px;">
  </div>

  <div class="bg-white">
    <div class="container padding-top-32">
      <form #formReturnData="ngForm" name="formReturnData"
        (ngSubmit)="handleFormSubmit(formReturnData, formReturnData.value, $event)">
        <div class="return-date-panel panel panel-default panel--shadow panel--visible margin-bottom-48">
          <div class="panel-body">

            <div class="flex-always flex--align-start flex--space-between">
              <h3 class="margin-top-0" [innerHTML]="appCopy.panelHeader['whenReturnFlightDateTitle'+selectedLanguage]">
                When is your return flight date?</h3>
            </div>
            <p [innerHTML]="appCopy.panelHeader['reminderRebook'+selectedLanguage]">We’ll confirm what services are available on your way back.</p>

            <div class="margin-top-12">
              <dp-date-picker
              theme="dp-portrTheme-default"
              (ngModelChange)="validateDate($event)"
              [config]="datepickerConfig"
              [ngModelOptions]="{standalone: true}"
              [ngClass]="{ 'has-error': returnDate.invalid && returnDate.dirty || returnDate.touched && !isReturnDateValid }"
              id="returnDate"
              name="returnDate"
              ngControl="returnDate"
              #returnDate="ngModel"
              [(ngModel)]="dateInput"
              ></dp-date-picker>

              <!-- <div class="flex-always" style="width: 100%;">
                <div class="form-group booking-referencer-input margin-bottom-0" style="width: 100%;">
                  <input class="form-control" (ngModelChange)="validateDate($event)" #dp="ngx-mydatepicker"
                  readonly (click)="dp.toggleCalendar()"
                    ngx-mydatepicker [options]="myOptions"
                    [ngClass]="{ 'has-error' : returnDate.invalid && returnDate.dirty || returnDate.touched && !isReturnDateValid}"
                    id="returnDate" name="returnDate" ngControl="returnDate" #returnDate="ngModel"
                    [(ngModel)]='dateInput' type="text" required appCheckEmpty>
                  <label class="control-label return-date-input-label" for="returnDate">dd/mm/yyyy</label>
                  <div class="form-group--links">
                    <a class="btn btn-link" href="javascript:void(0)" (click)="dp.toggleCalendar()"><i
                        class="icon">calendar</i></a>
                  </div>

                </div>
              </div>
-->
              <p class="help-block text-danger" [innerHTML]="appCopy.panelHeader[dateError+selectedLanguage]"
                *ngIf="returnDate.touched && (!isReturnDateValid || returnDate.invalid ) && returnDate.dirty">{{
                dateError }}</p>
            </div>
          </div>
        </div>

        <button type="submit" [ngClass]="{'Buttonloading' : isLoading}"
          class="btn btn-block btn-purple margin-bottom-24" [disabled]="isLoading">
          <span [innerHTML]="appCopy.panelHeader['buttonContinue'+selectedLanguage]">
            continue
          </span>
        </button>
      </form>

      <button type="button" [ngClass]="{'Buttonloading' : isLoading}"
        class="btn btn-ghost margin-bottom-24 border-0 margin-auto" (click)="abortFlyback()" [disabled]="isLoading">
        <span [innerHTML]="appCopy.panelHeader['noFlybackText'+selectedLanguage]">
          I don't have a return flight booked
        </span>
      </button>
    </div>
  </div>
</div>
